import React, { useMemo, useState } from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { JackpotComboBox, JackpotSelect } from '@screens/jackpot.winners/jackpot.winners.styles';
import JackpotWinnersList from '@screens/jackpot.winners/jackpot.winners.list';
import { praiasAppData, praiasAppWithBothData } from '@data/game.infos';

interface GameIDataProps {
  gameId?: string;
  app?: string;
}

interface GamesData {
  id: string;
  nickname: string;
  name: string;
  group: string;
  category: string;
}

const ComboBoxGames = () => {
  const { authorizedServices } = useAuth();
  const category = 'VB';

  async function getGamesId(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<GamesData[]>('/admin/domains/games', { params: { category }, cancelToken });
  }

  const { response, loading, validationErrors } = usePagedData(null, getGamesId, {});

  let gamesIdData: GamesData[] = [];
  if (response?.data) {
    gamesIdData = response?.data;
  }

  const [gameId, setGameId] = useState('');
  const [app, setGameApp] = useState(praiasAppWithBothData[2]);

  const listProps = useMemo<GameIDataProps>(() => ({ gameId, app }), [gameId, app]);

  function handleGameIdChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setGameId(e.target.value as string);
  }

  function handleGameAppChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setGameApp(e.target.value as string);
  }

  return (
    <>
      <JackpotComboBox>
        <FormControl>
          <InputLabel id='gameApp'>Praia</InputLabel>
          <JackpotSelect
            native
            labelId='Game App'
            id='gameApp'
            inputProps={{ name: 'gameApp' }}
            disabled={loading}
            onChange={handleGameAppChange}
            value={app}
          >
            {praiasAppWithBothData.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </JackpotSelect>
          <FormHelperText error>{validationErrors}</FormHelperText>
        </FormControl>
      </JackpotComboBox>
      <JackpotComboBox>
        <FormControl>
          <InputLabel id='vb'>VB</InputLabel>
          <JackpotSelect native labelId='VB' id='vb' inputProps={{ name: 'vb' }} disabled={loading} onChange={handleGameIdChange} value={gameId}>
            <option> </option>
            {gamesIdData.map((v) => (
              <option key={v.id} value={v.id}>
                {v.id}
              </option>
            ))}
          </JackpotSelect>
          <FormHelperText error>{validationErrors}</FormHelperText>
        </FormControl>
      </JackpotComboBox>
      <JackpotWinnersList {...listProps} />
    </>
  );
};

export default ComboBoxGames;
